import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import { Globals } from '../globals';
import { FirestoreService } from './firestore/firestore.service';

interface ActivityClassification {
    active: number;
    createdAt: any;
    description: string;
    name: string;
    perSection: boolean;
    updatedAt: any;
}

export interface ActivityClassificationId extends ActivityClassification {
    id: string;
}

@Injectable()
export class ActivityClassificationService {

    activityClassificationCollection: AngularFirestoreCollection<ActivityClassification>;
    activityClassifications: any;

    activityClassificationDocument: AngularFirestoreDocument<ActivityClassificationId>;
    activityClassification: Observable<ActivityClassificationId>;

    collection: string;

    constructor(private afs: AngularFirestore, private afh: FirestoreService) {
        this.collection = Globals.ACTIVITY_CLASSIFICATION_COLLECTION;
    }

    postActivityClassification(activityClassificationObject: ActivityClassification) {
		this.afh.add(`${this.collection}`, activityClassificationObject);
    }

    getActivityClassifications({onEmpty=undefined}={}) {
        this.activityClassificationCollection = this.afs.collection(this.collection, ref => ref.where('active', '==', true) );

        this.activityClassifications = this.activityClassificationCollection.snapshotChanges().map(actions => {
            if(!actions.length && onEmpty) onEmpty();
            return actions.map(a => {
                const id$ = a.payload.doc.id;

                const data = a.payload.doc.data() as ActivityClassification;

                const name = data.name;
                const description = data.description;
                const perSection = data.perSection;

                return { id$, name, description, perSection };
            });
        }).map(object => object);

        return this.activityClassifications;
    }

    getActivityClassification(id$: string) {
        this.activityClassificationDocument = this.afs.doc(this.collection + '/' + id$);

        this.activityClassification = this.activityClassificationDocument.valueChanges();

        return this.activityClassification.map(object => object);
    }

    putActivityClassification(activityClassificationObject: any, id$: string) {
		this.afh.update(`${this.collection}/${id$}`, activityClassificationObject);
    }

    delActivityClassification(id$: string) {
        this.afh.delete(`${this.collection}/${id$}`);
    }

}
